module.exports = __webpack_public_path__ + "static/media/bulk_master_transit.80197b84.csv";